// @flow
import CustomerSearch, { type CustomerSearchProps } from './customer-search';

export default CustomerSearch;
export type { CustomerSearchProps };
